export default __webpack_public_path__ + "static/media/Audiophile - Portfolio.172de9ca.png";